import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetSmsmessagesQueryVariables = Types.Exact<{
  moveId: Types.Scalars['bigint']['input'];
}>;


export type GetSmsmessagesQuery = { __typename?: 'query_root', smsmessages: Array<{ __typename?: 'smsmessages', id: number, move_id?: number | null, recipient_phone?: string | null, sender_phone?: string | null, message_body?: string | null, createdat?: string | null, updatedat?: string | null, status?: string | null, direction: string, metadata?: object | null, error?: string | null, createdby?: string | null }> };


export const GetSmsmessagesDocument = gql`
    query getSmsmessages($moveId: bigint!) {
  smsmessages(where: {move_id: {_eq: $moveId}}) {
    id
    move_id
    recipient_phone
    sender_phone
    message_body
    createdat
    updatedat
    status
    direction
    metadata
    error
    createdby
  }
}
    `;

/**
 * __useGetSmsmessagesQuery__
 *
 * To run a query within a React component, call `useGetSmsmessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsmessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsmessagesQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useGetSmsmessagesQuery(baseOptions: Apollo.QueryHookOptions<GetSmsmessagesQuery, GetSmsmessagesQueryVariables> & ({ variables: GetSmsmessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsmessagesQuery, GetSmsmessagesQueryVariables>(GetSmsmessagesDocument, options);
      }
export function useGetSmsmessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsmessagesQuery, GetSmsmessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsmessagesQuery, GetSmsmessagesQueryVariables>(GetSmsmessagesDocument, options);
        }
// @ts-ignore
export function useGetSmsmessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsmessagesQuery, GetSmsmessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsmessagesQuery, GetSmsmessagesQueryVariables>;
export function useGetSmsmessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsmessagesQuery, GetSmsmessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsmessagesQuery | undefined, GetSmsmessagesQueryVariables>;
export function useGetSmsmessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsmessagesQuery, GetSmsmessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsmessagesQuery, GetSmsmessagesQueryVariables>(GetSmsmessagesDocument, options);
        }
export type GetSmsmessagesQueryHookResult = ReturnType<typeof useGetSmsmessagesQuery>;
export type GetSmsmessagesLazyQueryHookResult = ReturnType<typeof useGetSmsmessagesLazyQuery>;
export type GetSmsmessagesSuspenseQueryHookResult = ReturnType<typeof useGetSmsmessagesSuspenseQuery>;
export type GetSmsmessagesQueryResult = Apollo.QueryResult<GetSmsmessagesQuery, GetSmsmessagesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/getSmsmessages.query.gql}
 */
export async function getSmsmessages(
  variables: GetSmsmessagesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetSmsmessagesQuery['smsmessages']>
export async function getSmsmessages(
  variables: GetSmsmessagesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetSmsmessagesQuery>
export async function getSmsmessages(
  variables: GetSmsmessagesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetSmsmessagesQuery['smsmessages'] | GetSmsmessagesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetSmsmessagesQuery>(
    GetSmsmessagesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.smsmessages
}